module.exports = __webpack_public_path__ + "static/media/history-black.15c54b57.svg";